import zk_shark_badge from 'assets/badges/zk_shark_badge.svg'
import wen_moon_badge from 'assets/badges/wen_moon_badge.svg'
import yolo_god_badge from 'assets/badges/yolo_god_badge.svg'
import shitcoin_sniper_badge from 'assets/badges/shitcoin_sniper_badge.svg'
import supreme_degen_badge from 'assets/badges/supreme_degen_badge.svg'
import rekt_newbie_badge from 'assets/badges/rekt_newbie_badge.svg'
import giga_chad_badge from 'assets/badges/giga_chad_badge.svg'
import doge_walker_badge from 'assets/badges/doge_walker_badge.svg'
import bit_farmer_badge from 'assets/badges/bit_farmer_badge.svg'

export const badges = {
  zk_shark_badge,
  wen_moon_badge,
  yolo_god_badge,
  shitcoin_sniper_badge,
  supreme_degen_badge,
  rekt_newbie_badge,
  giga_chad_badge,
  doge_walker_badge,
  bit_farmer_badge,
}
